// @generated by protoc-gen-es v1.3.3 with parameter "target=js+dts,import_extension=none"
// @generated from file common/v1/merchant_ops.proto (package common.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Struct } from "../../google/protobuf/struct_pb";
import { Timestamp } from "../../google/protobuf/timestamp_pb";

/**
 * @generated from message common.v1.MopConfiguration
 */
export const MopConfiguration = proto3.makeMessageType(
  "common.v1.MopConfiguration",
  () => [
    { no: 1, name: "payment_method_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "settlement_currency_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "point_of_sale_currency_code_list", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message common.v1.StratusConfiguration
 */
export const StratusConfiguration = proto3.makeMessageType(
  "common.v1.StratusConfiguration",
  () => [
    { no: 1, name: "merchant_acquirer_company_identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "merchant_acquirer_business_unit_identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "merchant_acquirer_transaction_division_identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "point_of_sale_currency_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "settlement_currency_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message common.v1.JpmcMerchant
 */
export const JpmcMerchant = proto3.makeMessageType(
  "common.v1.JpmcMerchant",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "client_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "event_source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "merchant_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "stratus_configuration", kind: "message", T: StratusConfiguration, repeated: true },
    { no: 7, name: "status_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "category_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "category_label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "legal_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "checkout_features", kind: "message", T: Struct },
    { no: 12, name: "checkout_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "fraud_check_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 14, name: "pinless_debit_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "three_ds", kind: "message", T: Struct },
    { no: 16, name: "address", kind: "message", T: Struct },
    { no: 17, name: "event", kind: "message", T: Struct },
    { no: 18, name: "transaction_ceiling_amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 19, name: "mop_configuration", kind: "message", T: MopConfiguration, repeated: true },
    { no: 20, name: "created_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "created_at", kind: "message", T: Timestamp },
    { no: 22, name: "updated_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 23, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 24, name: "wallet_config", kind: "message", T: WalletConfig },
    { no: 25, name: "enterprise_party_identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 26, name: "lpm_callback_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message common.v1.WalletConfig
 */
export const WalletConfig = proto3.makeMessageType(
  "common.v1.WalletConfig",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "values", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "paze_client_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message common.v1.JpmcMerchantAuditHistory
 */
export const JpmcMerchantAuditHistory = proto3.makeMessageType(
  "common.v1.JpmcMerchantAuditHistory",
  () => [
    { no: 1, name: "revision_metadata", kind: "message", T: RevisionMetadata },
    { no: 2, name: "payload", kind: "message", T: JpmcMerchant },
  ],
);

/**
 * @generated from message common.v1.RevisionMetadata
 */
export const RevisionMetadata = proto3.makeMessageType(
  "common.v1.RevisionMetadata",
  () => [
    { no: 1, name: "revision_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "revision_instant", kind: "message", T: Timestamp },
    { no: 3, name: "revision_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

